export const GET_LANGUAGES_DATA = 'GET_LANGUAGES_DATA'
export const SET_LANGUAGES_DATA = 'SET_LANGUAGES_DATA'
export const SET_LANGUAGES_ERROR = 'SET_LANGUAGES_ERROR'
export const SET_LANGUAGES_PROCESSING = 'SET_LANGUAGES_PROCESSING'

export function getLanguagesData () {
  return {
    type: GET_LANGUAGES_DATA,
  }
}

export function setLanguagesData ({ data }) {
  return {
    type: SET_LANGUAGES_DATA,
    payload: { data },
  }
}

export function setLanguagesError ({ error }) {
  return {
    type: SET_LANGUAGES_ERROR,
    payload: { error },
  }
}

export function setLanguagesProcessing ({ processing = true }) {
  return {
    type: SET_LANGUAGES_PROCESSING,
    payload: { processing },
  }
}
